import type DocumentFieldView from '@UI/Store/Documents/Views/DocumentFieldView';

/**
 * A boolean, or a choice with resolved options, corrects through `FieldOptionToggles` — never
 * through the free-text editor. A `host` choice (`options: null`, no catalogue to pick from) is
 * saved as plain text instead.
 */
const isOptionsBasedField = (field: DocumentFieldView): boolean =>
	field.fieldType.value === 'boolean' || (field.fieldType.value === 'choice' && field.options !== null);

export default isOptionsBasedField;
